import {observable,action} from 'mobx'
import {getVal,setVal} from '../../utils/server'

class DashboardStore{
  @observable dashboardMetricName = getVal("dashboardMetricName",'')
  @observable dashboardAlertName = getVal("dashboardAlertName",'')

  @action setDashboardMetricName(dashboardMetricName){
    this.dashboardMetricName= dashboardMetricName
    setVal("dashboardMetricName",this.dashboardMetricName)
  }
  @action setDashboardAlertName(dashboardAlertName){
    this.dashboardAlertName= dashboardAlertName
    setVal("dashboardAlertName",this.dashboardAlertName)
  }

}

export default new DashboardStore()


// WEBPACK FOOTER //
// ./src/routes/MonitorDashBoard/store.js